import React, { Fragment, Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import RouterLink from '../ReactMetismenuRouterLink';
import MetisMenu from 'haofun-react-metismenu';
import { useAuth0 } from "../../../auth/react-auth0-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import roles from "../../../auth/roles";

const createMenu = () => {

  const { user, activeTenant } = useAuth0();

  const isAdmin = user.isInRole([roles.ADMIN], activeTenant)

  const sidebarMenuContent = [];

  const tenantType = activeTenant ? activeTenant.type : user.getRole();

  if (user.isInRole([roles.AGENTE, roles.VENDITORE, roles.DEALER, roles.ADMIN], activeTenant)) {
    sidebarMenuContent.push(
      {
        label: 'Dashboard',
        icon: 'fas fa-tachometer-alt',
        description: '',
        to: `/tenant/dashboard`
      }
    )
  }

  if (user.isInRole([roles.AGENTE, roles.VENDITORE, roles.BACKOFFICE, roles.MARKETING, roles.DEALER, roles.ADMIN], activeTenant)) {

    const listMenu = {
      label: 'Elenco Vendite',
      description: '',
      to: `/tenant/sales`
    }
    const newMenu = {
      label: 'Nuova Vendita',
      description: '',
      to: `/tenant/sales-add`
    }

    const menu = [];
    menu.push(listMenu);

    if (tenantType == roles.VENDITORE || tenantType == roles.DEALER || isAdmin) {
      menu.push(newMenu);
    }

    sidebarMenuContent.push(
      {
        label: 'Vendite',
        icon: 'fas fa-hand-holding-usd',
        content: menu
      }
    )
  }

  if (user.isInRole([roles.AGENTE, roles.BACKOFFICE, roles.DEALER, roles.ADMIN], activeTenant)) {

    const listMenu = {
      label: 'Elenco Ordini',
      description: '',
      to: `/tenant/orders`
    }
    const newMenu = {
      label: 'Nuovo Ordine',
      description: '',
      to: `/tenant/add-order`
    }

    const menu = [];
    menu.push(listMenu);
    if (tenantType == roles.DEALER || isAdmin) {
      menu.push(newMenu);
    }

    sidebarMenuContent.push(
      {
        label: 'Ordini',
        icon: 'fas fa-truck',
        content: menu
      }
    )
  }

  if (user.isInRole([roles.VENDITORE, roles.BACKOFFICE, roles.SERVICE, roles.MARKETING, roles.DEALER, roles.ADMIN], activeTenant)) {

    const listMenu = {
      label: 'Elenco Clienti',
      description: '',
      to: `/tenant/customers`
    }
    const newMenu = {
      label: 'Nuovo Cliente',
      description: '',
      to: `/tenant/add-customer`
    }

    const menu = [];
    menu.push(listMenu);
    if (tenantType == roles.VENDITORE || tenantType == roles.BACKOFFICE || tenantType == roles.DEALER || isAdmin) {
      menu.push(newMenu);
    }

    sidebarMenuContent.push(
      {
        label: 'Clienti',
        icon: 'fas fa-users',
        content: menu
      }
    )
  }

  if (user.isInRole([roles.AGENTE, roles.BACKOFFICE, roles.DEALER, roles.ADMIN], activeTenant)) {

    sidebarMenuContent.push(
      {
        label: 'Magazzino',
        icon: 'fas fa-warehouse',
        description: '',
        to: `/tenant/storage`
      }
    )
  }

  if (isAdmin) {

    const listMenu = {
      label: 'Elenco Prodotti',
      description: '',
      to: `/tenant/products`
    }
    const newMenu = {
      label: 'Nuovo Prodotto',
      description: '',
      to: `/tenant/products-add`
    }

    const menu = [];
    menu.push(listMenu);
    if (isAdmin) {
      menu.push(newMenu);
    }

    sidebarMenuContent.push(
      {
        label: 'Prodotti',
        icon: 'fas fa-align-center',
        content: menu
      }
    )
  }

  if (user.isInRole([roles.SERVICE, roles.DEALER, roles.ADMIN], activeTenant)) {

    const listMenu = {
      label: 'Elenco Modelli',
      description: '',
      to: `/tenant/services`
    }
    const newMenu = {
      label: 'Nuovo Modello',
      description: '',
      to: `/tenant/services-add`
    }

    const menu = [];
    menu.push(listMenu);
    if (tenantType == roles.SERVICE || isAdmin) {
      menu.push(newMenu);
    }

    sidebarMenuContent.push(
      {
        label: 'Modelli Tagliando',
        icon: 'fas fa-wrench',
        content: menu
      }
    )
  }

  if (user.isInRole([roles.SERVICE, roles.DEALER, roles.ADMIN], activeTenant)) {

    sidebarMenuContent.push(
      {
        label: 'Gestione Richiami',
        icon: 'fas fa-tools',
        description: '',
        to: `/tenant/service-notifications`
      }
    )
  }

  if (user.isInRole([roles.DEALER, roles.ADMIN, roles.MARKETING], activeTenant)) {


    const listMenu = {
      label: 'Elenco Campagne',
      description: '',
      to: `/tenant/marketing`
    }
    const newMenu = {
      label: 'Nuova Campagna',
      description: '',
      to: `/tenant/marketing-add`
    }

    const menu = [];
    menu.push(listMenu);
    if (tenantType == roles.MARKETING || isAdmin) {
      menu.push(newMenu);
    }

    sidebarMenuContent.push(
      {
        label: 'Campagne Marketing',
        icon: 'fas fa-mail-bulk',
        content: menu
      }
    )
  }

  if (user.isInRole([roles.AGENTE, roles.VENDITORE, roles.BACKOFFICE, roles.SERVICE, roles.MARKETING, roles.DEALER, roles.ADMIN], activeTenant)) {
    sidebarMenuContent.push(
      {
        label: 'Struttura Dealer',
        icon: 'fas fa-sitemap',
        description: '',
        to: `/tenant/structure`
      }
    )
  }

  return sidebarMenuContent;
}

const SidebarMenu = () => {

  const { user } = useAuth0();

  const sidebarMenuContent = createMenu();

  return (
    <Fragment>
      <PerfectScrollbar>
        <div className="sidebar-navigation">
          <div className="sidebar-header">
            <span><FontAwesomeIcon icon="user" /> {user.name}: {user["https://piramis.com/user_metadata"].role}</span>
          </div>
          <MetisMenu
            content={sidebarMenuContent}
            LinkComponent={RouterLink}
            activeLinkFromLocation
            iconNamePrefix=""
            noBuiltInClassNames={true}
            classNameItemActive="active"
            classNameIcon="sidebar-icon"
            iconNameStateVisible="sidebar-icon-indicator"
            iconNameStateHidden="sidebar-icon-indicator"
            classNameItemHasVisibleChild="submenu-open"
            classNameItemHasActiveChild="active"
            classNameStateIcon="fas fa-caret-down"
          />
        </div>
      </PerfectScrollbar>
    </Fragment>
  );
}

export default SidebarMenu;
